import posthog from "posthog-js";
import { config } from "./config";

export const initPostHog = () => {
  if (config.POSTHOG_KEY) {
    posthog.init(config.POSTHOG_KEY, {
      api_host: 'https://us.i.posthog.com',
      capture_pageview: false, // We'll handle this manually
      capture_pageleave: true,
      autocapture: true,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: true,
        maskInputOptions: {
          password: true,
          email: true,
          tel: true,
        },
      },
    });
  }
};

export const identifyUser = (userId: string, userProperties: Record<string, any>) => {
  if (config.POSTHOG_KEY) {
    posthog.identify(userId, userProperties);
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (config.POSTHOG_KEY) {
    posthog.capture(eventName, properties);
  }
};

// Helper function to track page views
export const trackPageView = (url: string) => {
  if (config.POSTHOG_KEY) {
    posthog.capture('$pageview', { $current_url: url });
  }
};

export const resetSession = () => {
  if (config.POSTHOG_KEY) {
    posthog.reset();
  }
};

export const setUserProperties = (properties: Record<string, any>) => {
  if (config.POSTHOG_KEY) {
    posthog.people.set(properties);
  }
};
